import { SnappingMethods } from "../enums";
const ADVANCED_PATTERNS = [SnappingMethods.ADVANCED, 'advanced'], DEFAULT_PATTERN = [SnappingMethods.NORMAL, 'normal'];
export const isSnappingMethodAdvenced = (method) => {
    return ADVANCED_PATTERNS.includes(method);
};
export const isSnappingMethodDefault = (method) => {
    return DEFAULT_PATTERN.includes(method);
};
